"use client";

import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useLocale } from "next-intl";
import { useTranslatedData } from "@/data";
import { Button } from "./ui/button";

function BurgerMenu() {
  const [isChecked, setIsChecked] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const burgerRef = useRef<HTMLLabelElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { navItems } = useTranslatedData();
  const locale = useLocale();

  const toggleCheckbox = () => setIsChecked(!isChecked);

  const handleOutsideClick = (e: MouseEvent) => {
    const target = e.target as Node;
    const portal = document.querySelector("[data-radix-portal]");
    if (portal && portal.contains(target)) return;

    if (
      contentRef.current &&
      burgerRef.current &&
      dropdownRef.current &&
      !contentRef.current.contains(target) &&
      !burgerRef.current.contains(target) &&
      !dropdownRef.current.contains(target)
    ) {
      setIsChecked(false);
    }
  };

  const handleContentClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    if (
      target.closest("button") ||
      target.closest("a") ||
      target.closest("input") ||
      target.closest("label") ||
      target.closest('[role="menu"]') ||
      target.closest('[role="menuitem"]')
    ) {
      return;
    }
    setIsChecked(false);
  };

  useEffect(() => {
    if (isChecked) {
      document.addEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "hidden";
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "";
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.body.style.overflow = "";
    };
  }, [isChecked]);

  return (
    <>
      <input
        type="checkbox"
        id="checkbox"
        name="burger"
        checked={isChecked}
        onChange={toggleCheckbox}
        style={{ display: "none" }}
      />

      <label
        ref={burgerRef}
        className="containerzz burger-visiblezz cursor-pointer"
        htmlFor="checkbox"
      >
        <div className="burger-menuzz topzz"></div>
        <div className="burger-menuzz bottomzz"></div>
      </label>

      {isChecked && (
        <Sheet open={isChecked} onOpenChange={setIsChecked}>
          <SheetContent
            side="top"
            className="flex flex-col items-center gap-6 py-10 px-6 backdrop-blur-md border border-blue-/30 rounded-b-2xl glass-sheet sheet-content no-underline [&>button]:hidden"
            style={{ paddingTop: "170px" }}
          >
            {/* ✅ Hidden title required by Radix */}
            {/* <SheetTitle className="sr-only">Navigation Menu</SheetTitle> */}

            <div
              ref={contentRef}
              className="flex flex-col items-center gap-6"
              onClick={handleContentClick}
            >
              <div className="flex flex-col items-center gap-4 w-full max-w-xs">
                {navItems.map((item, idx) => {
                  const href = item.link;
                  const isProjects = href.includes("/projects");

                  return (
                    <div key={idx} className="no-underline">
                      <Button
                        asChild
                        variant="secondary"
                        className="no-underline btn-shine"
                        onClick={(e) => {
                          setIsChecked(false);
                          if (isProjects) {
                            e.preventDefault();
                            window.location.href = href; // 🔥 force full reload for /projects
                          }
                        }}
                      >
                        <Link href={href}>{item.name}</Link>
                      </Button>
                    </div>
                  );
                })}
              </div>

              <div
                ref={dropdownRef}
                className="mt-6"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                {/* <LocalSwitcher /> */}
              </div>
            </div>
          </SheetContent>
        </Sheet>
      )}
    </>
  );
}

export default BurgerMenu;
